import React from 'react';
import PanelRequest from './Add_Panel_Request';
import { api_srv } from 'services';
import { DashboardContext } from 'context/DashboardContext';
import { useContext } from 'react';
import { show_toast } from 'utils/helpers';
import { useCallback } from 'react';

function PanelRequestContainer(props) {
 const { addRequest, setRequest } = useContext(DashboardContext);


  const add_request = useCallback(async (payload) => {
    // setAddDepartment({ ...addDepartment, loading: true });
    try {
    let resp = await (await api_srv).addPanelRequest(payload);
     console.log("resp===", resp)

    //   setAddDepartment({ ...addDepartment, loading: false });
    //   refetch();
     props.onHide(false);
     show_toast("Request sent successfully", "success");
    } catch (err) {
     props.onHide(false);
    //   setAddDepartment({ ...addDepartment, loading: false });
    }
  });
    return (
        <div>
            <PanelRequest onSubmit={add_request} {...props}  />
        </div>
    );
}

export default PanelRequestContainer;